(function () {
  const scrollTopButton = document.getElementById('scroll-top');
  if (!scrollTopButton) return;

  const progressIndicator = document.getElementById('progress-indicator');
  const radius = progressIndicator ? progressIndicator.r.baseVal.value : 34;
  const circumference = 2 * Math.PI * radius;

const SHOW_THRESHOLD = 300;
  let lastScrollY = window.scrollY;
  let suppressed = false;

  function getMaxScroll() {
    return Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
  }

  function update() {
    const currentY = window.scrollY;
    const maxScroll = getMaxScroll();
    const isScrollDown = currentY > lastScrollY;
    lastScrollY = currentY;

    // Only hide after the button was clicked; a new downward scroll reveals it again.
    if (isScrollDown) suppressed = false;

    const progress = maxScroll > 0 ? Math.min(currentY / maxScroll, 1) : 0;

    if (progressIndicator) {
      progressIndicator.style.strokeDasharray = `${circumference * progress}, ${circumference}`;
    }

    const shouldShow = !suppressed && currentY > SHOW_THRESHOLD;
    scrollTopButton.classList.toggle('show', shouldShow);
    scrollTopButton.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);

  scrollTopButton.addEventListener('click', function (event) {
    event.preventDefault();
    suppressed = true;
    scrollTopButton.classList.remove('show');
    scrollTopButton.setAttribute('aria-hidden', 'true');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  update();
})();